import { createFeatureSelector, createSelector } from '@ngrx/store';
import { memoize } from 'lodash';
import { configurationEntityAdapter } from '../adapters/configuration.adapter';
import { GenesysCloudWebDeploymentsState } from '../genesys-cloud-web-deployments.state';
import { featureKey } from '../reducers/feature-key';

const { selectEntities } = configurationEntityAdapter.getSelectors();

const selectState = createFeatureSelector<GenesysCloudWebDeploymentsState>(featureKey);
const selectConfigurationSubState = createSelector(selectState, (state) => state.configurations);
const selectConfigurationEntities = createSelector(selectConfigurationSubState, selectEntities);

const selectConfigurationByDeploymentId = memoize((deploymentId: string) =>
  createSelector(selectConfigurationEntities, (entities) => entities[deploymentId])
);

export const selectShowAgentTypingIndicator = memoize((deploymentId: string) =>
  createSelector(
    selectConfigurationByDeploymentId(deploymentId),
    (configuration) => configuration?.configurationVersion?.messenger?.apps?.conversations?.showAgentTypingIndicator
  )
);

export const selectCobrowseEnabled = memoize((deploymentId: string) =>
  createSelector(
    selectConfigurationByDeploymentId(deploymentId),
    (configuration) => configuration?.configurationVersion?.cobrowse?.enabled
  )
);
